import { useContext, useMemo } from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { ActionButton } from '@hdi-seguros/web-components.action-button';

import { formattedPrice } from '../../../../../../../../../shared/utils';
import { Column } from '../../../../../../../../production/InsurancePolicyDetail/utils/renderSections';
import { GenericDataFormContext, QUOTATION_BUTTON, QuotationInfoContext, StepOneFormContext } from '../../../../../shared';
import { StepThreeFormContext } from '../../contexts/StepThreeForm';
import { SectionSummary } from '../../../../../../../../../shared/components';
import { getExplanatoryTexts, getQuoteDocumentPDF, transformToPdfQuote } from '../../../../../utils';
import { BranchDocumentsURL, BudgetType } from '../../../../../utils/quotation-documents.enum';
import { QuotationContextData } from '../../../../../../../../../shared/interfaces/services/quote-pdf-service';
import { StepTwoFormContext } from '../../../StepTwo/contexts/StepTwoForm';
import { MasterContext } from '../../../../../../../../../shared/contexts';

export const Summary = () => {

  const { quotationResponse, labelButton, homePaymentMethodsForm, homeQuotationComponents } = useContext( StepThreeFormContext )
  const { stepOneForm, clientSelected } = useContext(StepOneFormContext);
  const { stepTwoForm, activeKey, tabs, housingTypeOptionsPerPlan, planOptionsBySelectedPlan } = useContext(StepTwoFormContext);
  const { quotationInfo } = useContext(QuotationInfoContext);
  const { provinceList, allLocalitiesPerProvince, paymentMethodSectionForm, ivaConditionList, paymentMethods, allCoveragesPerPlan, paymentMethodsList } = useContext(GenericDataFormContext);
  const { globalPublicConfigs } = useContext(MasterContext);

  const ctx: QuotationContextData = {
    stepOneForm,
    clientSelected,
    stepTwoForm, activeKey, tabs, housingTypeOptionsPerPlan, planOptionsBySelectedPlan,
    quotationResponse, homePaymentMethodsForm,
    quotationInfo, paymentMethodsList, homeQuotationComponents,
    provinceList, allLocalitiesPerProvince, paymentMethodSectionForm, ivaConditionList, paymentMethods, allCoveragesPerPlan,
    branchDocumentsURL: BranchDocumentsURL.HOGAR
  };

  const ensureExplanatoryTextReady = () => {
    const plan = stepTwoForm?.getFieldValue(`plan-tab-${activeKey}`);
    if (!plan) return false;

    let text = stepTwoForm?.getFieldValue(`explanatory-text-tab-${activeKey}`);
    if (text==undefined) {
      text = getExplanatoryTexts(
        Number(quotationInfo?.branch),
        Number(quotationInfo?.article),
        Number(plan),
        globalPublicConfigs?.QUOTATION_EXPLANATORY_TEXTS
      ) || '';
      stepTwoForm?.setFieldValue(`explanatory-text-tab-${activeKey}`, text);
    }
    return true;
  };

  const handleDownloadQuote = (budgetType : BudgetType) => {
    if (!ensureExplanatoryTextReady()) return;
    getQuoteDocumentPDF(
      transformToPdfQuote(ctx, budgetType),
      BranchDocumentsURL.HOGAR
    );
  };

  const summaryInfo: Array<Column[]> = useMemo(() => [
    [
      {
        label: 'Total suma asegurada:',
        value: labelButton === QUOTATION_BUTTON.RECOTIZAR ? labelButton : <b>{ `$ ${ formattedPrice( quotationResponse?.sumaAsegurada )}` }</b>,
        columnSize: {
          sm: { span: 12 },
          xs: { span: 12 },
          md: { span: 10 },
          lg: { span: 7 },
        },
      },
      {
        label: 'Prima técnica:',
        value: labelButton === QUOTATION_BUTTON.RECOTIZAR ? labelButton : <>{ `$ ${ formattedPrice( quotationResponse?.prima )}` }</>,
        columnSize: {
          sm: { span: 12 },
          xs: { span: 12 },
          md: { span: 7 },
          lg: { span: 7 },
        },
      },
      {
        label: 'Comisión:',
        value: labelButton === QUOTATION_BUTTON.RECOTIZAR ? labelButton : <>{ `$ ${ formattedPrice( quotationResponse?.condicionesComerciales.impComision )}` }</>,
        columnSize: {
          sm: { span: 12 },
          xs: { span: 12 },
          md: { span: 6 },
          lg: { span: 7 },
        },
      },
      {
        label: 'Premio:',
        value: labelButton === QUOTATION_BUTTON.RECOTIZAR ? labelButton : <>{ `$ ${ formattedPrice( quotationResponse?.premio )}` }</>,
        columnSize: {
          sm: { span: 12 },
          xs: { span: 12 },
          md: { span: 10 },
          lg: { span: 7 },
        },
      },
      {
        label: 'Acciones',
        value: labelButton === QUOTATION_BUTTON.RECOTIZAR ? labelButton : (
          <>
            <ActionButton
              className='btn-accent-outline-barbuss'
              type='secondary'
              label='Productor'
              onClick={() => { handleDownloadQuote(BudgetType.PRODUCTOR)}}
              icon={<DownloadOutlined />}
            />
            <ActionButton
              className='btn-accent-outline-barbuss'
              type='secondary'
              style={{ marginLeft: '1rem' }}
              color='secondaryDefault'
              label='Cliente'
              onClick={() => { handleDownloadQuote(BudgetType.CLIENTE)}}
              icon={<DownloadOutlined />}
            />
          </>
        ),
        columnSize: {
          sm: { span: 24 },
          xs: { span: 24 },
          md: { span: 14 },
          lg: { span: 10 },
        },
      },
    ],
  ], [ labelButton, quotationResponse ])

  return <SectionSummary summaryInfo={summaryInfo} />
};